var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71942 6.09116C4.5049 6.27302 4.57259 6.58998 4.63326 6.72573C5.49466 9.23199 7.00753 10.6941 7.93009 11.3861C8.38102 11.7244 8.61269 11.5807 8.76851 11.5009C8.92433 11.4211 9.40879 10.9353 9.91806 10.513C10.4273 10.0906 10.7964 10.3675 11.0224 10.4961C11.2484 10.6248 12.9152 11.9297 13.3773 12.401C13.747 12.778 13.6493 13.188 13.5542 13.3459C12.8358 15.9372 10.1791 15.7876 8.94053 15.3889C3.31697 13.0829 1.45348 6.53741 1.34619 6.14725C1.26036 5.83513 1.05677 5.06109 1.08734 4.52935C1.23913 1.88924 2.35462 1.0474 3.04902 0.763621C3.87232 0.427162 4.58541 0.576169 4.95472 0.679871C5.32403 0.783574 5.53112 1.0811 5.56818 1.26276C5.59782 1.40809 5.91898 3.33787 6.07584 4.2846C6.16193 4.93932 5.77113 5.27329 5.66716 5.38422C5.56318 5.49514 4.98758 5.86383 4.71942 6.09116Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e95154a5c769a2d236ae8ac3d6b38a6a.svg";
export { ForwardRef as ReactComponent };